"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var React = require("react");
var IconButton_1 = require("@mui/material/IconButton");
var PhoneAndroid_1 = require("@mui/icons-material/PhoneAndroid");
require("./fe-page.scss");
var fe_services_1 = require("./fe_services");
var react_query_1 = require("react-query");
function FEAppVersion() {
    var _a = (0, react_1.useState)('--'), appVersion = _a[0], setAppVersion = _a[1];
    var _b = (0, react_1.useState)(false), spinning = _b[0], setSpinning = _b[1];
    var refetch = (0, react_query_1.useQuery)(['fe-app-version'], function () {
        return (0, fe_services_1.fetchFEAppVersion)();
    }, {
        retry: false,
        onSuccess: function (response) {
            setAppVersion(response);
            setSpinning(false);
        },
        onError: function (err) {
            setAppVersion('--');
            setSpinning(false);
        },
    }).refetch;
    var handleRefresh = function () {
        if (spinning)
            return;
        setSpinning(true);
        refetch();
    };
    return (React.createElement("div", { className: "version-chip" },
        React.createElement("div", { className: "version-chip__body" },
            React.createElement(PhoneAndroid_1.default, { className: "version-chip__icon" }),
            React.createElement("span", { className: "version-chip__label" }, "FE App Version"),
            React.createElement("span", { className: "version-chip__pipe" }, "|"),
            React.createElement("span", { className: "version-chip__version" },
                "v",
                appVersion)),
        React.createElement("div", { className: "version-chip__divider" }),
        React.createElement(IconButton_1.default, { className: "version-chip__refresh".concat(spinning ? " version-chip__refresh--spin" : ""), onClick: handleRefresh, "aria-label": "Refresh app version", disableRipple: true, size: "small" },
            React.createElement("span", { className: 'icon-refresh version-chip__refresh-icon' }))));
}
exports.default = FEAppVersion;
